import BrandService from '@/services/brand.service'
import {
  BRANDS_CREATE_BRAND,
  BRANDS_DELETE_BRAND,
  BRANDS_FETCH_ALL,
  BRANDS_UPDATE_BRAND,
  BRANDS_OPTIMISTIC_BRAND_UPDATE,
} from './action.types.js'
import { BRANDS_SET_BRANDS, BRANDS_SET_OPTIMISTIC_BRAND_UPDATE } from './mutation.types.js'

const state = {
  brands: [],
}

const getters = {
  brands: state => state.brands,
  brandByID: state => brandId => state.brands.find(brand => brand.id === brandId),
}

const actions = {
  async [BRANDS_FETCH_ALL]({ commit }) {
    const brands = await BrandService.findAll()
    commit(BRANDS_SET_BRANDS, brands)
  },
  // eslint-disable-next-line no-empty-pattern
  async [BRANDS_CREATE_BRAND]({}, brand) {
    const response = await BrandService.create(brand)
    return response
  },
  // eslint-disable-next-line no-empty-pattern
  async [BRANDS_UPDATE_BRAND]({}, brand) {
    const response = await BrandService.update(brand.id, brand)
    return response
  },
  async [BRANDS_DELETE_BRAND]({ dispatch }, brandId) {
    await BrandService.delete(brandId)
    dispatch(BRANDS_FETCH_ALL)
  },
  async [BRANDS_OPTIMISTIC_BRAND_UPDATE]({ commit }, brand) {
    commit(BRANDS_SET_OPTIMISTIC_BRAND_UPDATE, brand)
  },
}
const mutations = {
  [BRANDS_SET_BRANDS](state, brands) {
    state.brands = brands
  },
  [BRANDS_SET_OPTIMISTIC_BRAND_UPDATE](state, currentBrand) {
    const index = state.brands.findIndex(brand => brand.id === currentBrand.id)
    state.brands[index] = currentBrand
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
